module.exports = __webpack_public_path__ + "media/FoamRubber.91b61e35.mp3";